export default "__VITE_ASSET__e56d06f2__"